<template>
    <div class="margin-40-60-0 selfInfo">
        <div style="width: 30%;float: left">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>个人信息</span>
                </div>
                <div class="text item">
                    <div style="height: 140px">
                        <img style="text-align: center;border-radius: 100%;width: 120px;height: 120px;margin: auto" v-if="upsertForm.portrait" :src="adminAvatar" class="uploader-img">
                    </div>
                    <el-divider></el-divider>
                    <div style="height: 30px;line-height: 30px;font-size: 14px!important;">
                        <span class="el-icon-user-solid">登录用户名</span>
                        <span style="float: right">{{upsertForm.username}}</span>
                    </div>
                    <el-divider></el-divider>
                    <div style="height: 30px;line-height: 30px;font-size: 14px!important;">
                        <span class="iconfont icon-kehuqunzu" style="font-size: 14px!important;">所属角色</span>
                        <span style="float: right">{{upsertForm.roleNames}}</span>
                    </div>
                    <el-divider></el-divider>
                    <div style="height: 30px;line-height: 30px;font-size: 14px!important;">
                        <span class="el-icon-s-custom" style="font-size: 14px!important;">真实姓名</span>
                        <span style="float: right">{{upsertForm.realName}}</span>
                    </div>
                    <el-divider></el-divider>
                    <div style="height: 30px;line-height: 30px;font-size: 14px!important;">
                        <span class="el-icon-s-order" style="font-size: 14px!important;">公司名称</span>
                        <span style="float: right">{{upsertForm.unitName}}</span>
                    </div>
                    <el-divider></el-divider>
                    <div style="height: 30px;line-height: 30px;font-size: 14px!important;">
                        <span class="el-icon-phone" style="font-size: 14px!important;">手机号</span>
                        <span style="float: right">{{upsertForm.phone}}</span>
                    </div>
                    <el-divider></el-divider>
                    <div style="height: 30px;line-height: 30px;font-size: 14px!important;">
                        <span class="iconfont icon-clock_fill" style="font-size: 14px!important;">创建时间</span>
                        <span style="float: right">{{upsertForm.createTime}}</span>
                    </div>
                </div>
            </el-card>
        </div>
        <div style="width: 68%;float: left;margin-left: 20px">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>基本资料</span>
                </div>
                <div style="height: 630px">
                    <el-tabs  v-model="activeName">
                        <el-tab-pane label="基本信息" name="first">
                            <el-form class="upsertForm" :model="upsertForm" :rules="rules" ref="upsertForm" label-width="100px">
                                <input type="hidden" :value="upsertForm.id">
                                <el-form-item label="头像" prop="portrait">
                                    <el-upload
                                            class="el-uploader"
                                            :headers="{token:$store.getters.getToken}"
                                            :action="uploadAvatarUrl"
                                            :show-file-list="false"
                                            :on-progress="avatarUploadProgress"
                                            :on-success="uploadAvatarSuccess"
                                            :on-error="uploadAvatarError"
                                            :before-upload="beforeAvatarUpload">
                                        <img v-if="upsertForm.portrait" :src="adminAvatar" class="uploader-img">
                                        <i v-else class="el-icon-plus el-uploader-icon"></i>
                                    </el-upload>
                                </el-form-item>
                                <el-form-item label="用户名" prop="username">
                                    <el-input size="mini" v-model="upsertForm.username" disabled auto-complete="off"></el-input>
                                </el-form-item>
                                <el-form-item label="真实姓名" prop="realName">
                                    <el-input size="mini" v-model="upsertForm.realName" auto-complete="off"></el-input>
                                </el-form-item>
                                <el-form-item label="公司名称" prop="unitName">
                                    <el-input size="mini" v-model="upsertForm.unitName" auto-complete="off"></el-input>
                                </el-form-item>
                                <el-form-item label="手机号码" prop="phone">
                                    <el-input size="mini" v-model="upsertForm.phone" auto-complete="off"></el-input>
                                </el-form-item>
                                <!--<el-form-item label="修改密码" >-->
                                    <!--<el-button  class="table-edit" plain size="mini" v-display:updateMyPassword @click="showUpdateDialog()">修改</el-button>-->
                                <!--</el-form-item>-->
                            </el-form>
                            <div class="dialog-footer" style="text-align: left">
                                <el-button type="primary"  size="mini" @click="updateMySelf">保 存</el-button>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="修改密码"  name="second">
                            <el-form class="upsertForm" :model="pwdForm" :rules="pwdFormRules" ref="pwdForm" label-width="100px">
                                <el-form-item label="原密码" prop="password">
                                    <el-input type="password" placeholder="请输入原密码" v-model="pwdForm.password" auto-complete="off"></el-input>
                                </el-form-item>
                                <el-form-item label="新密码" prop="newPassword" style="margin-top: 15px;">
                                    <el-input type="password" placeholder="请输入新密码" v-model="pwdForm.newPassword" auto-complete="off"></el-input>
                                </el-form-item>
                                <el-form-item label="重复新密码" prop="newPassword2" style="margin-top: 15px;">
                                    <el-input type="password" placeholder="请再次输入原密码" v-model="pwdForm.newPassword2" auto-complete="off"></el-input>
                                </el-form-item>
                            </el-form>
                            <div class="dialog-footer" style="text-align: left">
                                <el-button size="mini" type="primary"  @click="updatePassword()">保 存</el-button>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </el-card>
        </div>
        <!-- 修改密码-begin -->
        <el-dialog  :close-on-click-modal="false" :title="dialog.title" width="640px" :visible.sync="dialog.dialogFormVisible">
            <el-form class="upsertForm" :model="pwdForm" :rules="pwdFormRules" ref="pwdForm" label-width="100px">
                <el-form-item label="原密码" prop="password">
                    <el-input type="password" placeholder="请输入原密码" v-model="pwdForm.password" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="newPassword" style="margin-top: 15px;">
                    <el-input type="password" placeholder="请输入新密码" v-model="pwdForm.newPassword" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="重复新密码" prop="newPassword2" style="margin-top: 15px;">
                    <el-input type="password" placeholder="请再次输入原密码" v-model="pwdForm.newPassword2" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div  class="dialog-footer" style="text-align: right">
                <el-button  plain size="mini" @click="dialog.dialogFormVisible = false">取 消</el-button>
                <el-button  plain size="mini" type="primary"  @click="updatePassword()">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 修改密码-end -->
    </div>
</template>

<script>
    import axios from 'axios'
    import md5 from 'md5'
    export default {
        name: "self",
        data(){
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else {
                    if (this.pwdForm.newPassword !== '') {
                        this.$refs.pwdForm.validateField('newPassword2');
                    }
                    callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.pwdForm.newPassword) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return {
                /*对话框*/

                dialog:{
                    dialogFormVisible:false,
                    title:'修改密码'
                },
                /**/
                portrait:'',
               // ok:false,
                activeName:'first',
                config:config,
                uploadAvatarUrl:`${home}/upload/uploadAvatar`,
                upsertForm:{
                    id:'',
                    username:'',
                    password:'',
                    realName:'',
                    phone:'',
                    unitName:'',
                    portrait:'',
                    departmentId:'',
                    departmentName:'',
                    createTime:'',
                    cityId:'',
                    provinceId:'',
                    jobId:'',
                    jobName:'',
                    updateTime:''
                },
                infoForm:{
                    id:'',
                    username:'',
                    password:'',
                    realName:'',
                    phone:'',
                    email:'',
                    portrait:'',
                    departmentId:'',
                    departmentName:'',
                    createTime:'',
                    cityId:'',
                    provinceId:'',
                    jobId:'',
                    jobName:'',
                    updateTime:''
                },
                rules: {
                   /* username: [
                        { required: true, message: '请输入用户名', trigger: 'blur' }
                    ],*/
                    realName: [
                        { required: true, message: '请输入真实姓名', trigger: 'blur' }
                    ],
                    phone: [
                        {required: true, message: '请输入联系电话', trigger: 'blur'},
                        {min:11, message: '必须是11位长度', trigger: 'blur'},
                        {max:11, message: '必须是11位长度', trigger: 'blur'},
                        { pattern: /^1[23456789]\d{9}$/, message: '目前只支持中国大陆的手机号码' }
                     ],
                    unitName: [
                        {required: true, message: '请输入公司名称', trigger: 'blur'},
                        {max: 255, message: '长度必须少于255个字符', trigger: 'blur'}
                    ],
                    portrait: [
                        { required: true, message: '请输入头像', trigger: 'blur' }
                    ]
                  /*  createTime: [
                        { required: true, message: '请输入创建时间', trigger: 'blur' }
                    ]*/
                },
                pwdForm:{
                    password:'',
                    newPassword:'',
                    newPassword2:''
                },
                pwdFormRules:{
                    password:[
                        {required: true, message: '请输入原始密码', trigger: 'blur'}
                    ],
                    newPassword:[
                        { validator: validatePass, trigger: 'blur' }
                    ],
                    newPassword2:[
                        { validator: validatePass2, trigger: 'blur' }
                    ],
                }
            }
        },
        created(){
            axios({
                url:`${home}/admin/ignore/findMySelf`,
                method:'GET'
            }).then(res=>{
                Object.assign(this.upsertForm,res.data);
                Object.assign(this.infoForm,res.data);
            })
        },
        methods:{
            showUpdateDialog(){
                this.dialog.dialogFormVisible=true;
                this.dialog.title = '修改密码';
            },
            closeDialog(){
                this.$emit('update:visible',false);
            },
            uploadAvatarSuccess(response, file, fileList){
                this.upsertForm.portrait=response;
                loading.close();
            },
            updateMySelf(){
                this.$refs['upsertForm'].validate(valid =>{
                    if(valid){
                        axios({
                            url:`${home}/admin/ignore/updateMySelf`,
                            method:"POST",
                            data:this.upsertForm
                        }).then(res=>{
                            this.$store.commit('setAdmin', res.data);
                            this.$message({
                                type: 'success',
                                message: '修改成功!'
                            });
                            Object.assign(this.infoForm,res.data);
                        })
                    }
                })

            },
            updatePassword(){
                this.$refs['pwdForm'].validate(valid =>{
                    if(valid){
                        axios({
                            url:`${home}/admin/ignore/updateMyPassword`,
                            method:'POST',
                            data:{password:md5(this.pwdForm.password),newPassword:md5(this.pwdForm.newPassword)}
                        }).then(res=>{
                            this.$message({
                                showClose: true,
                                message: '修改密码成功',
                                type: 'success'
                            });
                            this.closeDialog();
                            this.$router.replace('/login');
                        })
                    }
                })

            },
            beforeAvatarUpload(file){
                loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
            },
            avatarUploadProgress(event, file, fileList){

            },
            uploadAvatarError(err, file, fileList){
                loading.close();
            }
        },
        computed:{
            adminAvatar(){
                return config.resPre+this.upsertForm.portrait;
            }
        }
    }
    let loading;
</script>

<style scoped lang="scss">
    .upsertForm {
        padding: 20px 50px;
        .el-input, .el-textarea {
            width: 60%;
        }
    }
    .avatar{
        width:80px;
        height:80px;
        border-radius: 5px;
    }
    .dialog-footer{
        text-align: center;
    }
    .selfInfo{
        .el-divider--horizontal {
            display: block;
            height: 1px;
            width: 100%;
            margin: 15px 0;
        }
    }
</style>
